<div class="col-xs-1 center-block">
  <sanabel-selectize appcode="1277" [simpleView]="true" [(ngModel)]="updateComingFrom"
    [ngModelOptions]="{ standalone: true }"></sanabel-selectize>
</div>
<div class="row">
  <div class="col text-center">
    <!-- <button class="btn btn-success" (click)="save()"> save</button> -->
    <!-- [disabled]="DoctorsFeesClaim.length == 0"  -->
    <btns-ctrl #btnCtrl [appCodes]="[1]" (clicked)="updateComingForm()"></btns-ctrl>
  </div>
</div>